import React from 'react'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'
import * as Sentry from '@sentry/react'
import { useLocation } from 'react-router-dom'
import { WemoloTypography } from '../Wemolo'
import styles from './LocalErrorBoundary.module.css'

interface LocalErrorBoundaryProps {
    children: React.ReactNode
    tag: string // name of the component for tagging in Sentry Dashboard,
    keyToRerenderSection?: string | null
}

const SectionFallback = ({ error, resetErrorBoundary }: FallbackProps) => (
    <div role="alert" className={styles.fallback}>
        <WemoloTypography variant="body-medium" tag="p">
            Oops! This section failed to load.
        </WemoloTypography>
        <details>
            <summary>Error details</summary>
            <pre>{error.message}</pre>
        </details>
        <button onClick={resetErrorBoundary}>Try Again</button>
    </div>
)

const LocalErrorBoundary = ({ children, tag, keyToRerenderSection }: LocalErrorBoundaryProps) => {
    const location = useLocation()
    return (
        <ErrorBoundary
            {...(keyToRerenderSection ? { key: keyToRerenderSection } : {})}
            FallbackComponent={SectionFallback}
            onError={(error, info) => {
                console.error('error', error)
                Sentry.setTag('component', tag)
                Sentry.setContext('route', { pathname: location.pathname })
                Sentry.captureException(error, {
                    extra: {
                        componentStack: info.componentStack
                    }
                })
            }}
        >
            {children}
        </ErrorBoundary>
    )
}

export default LocalErrorBoundary
